<template>
  <div>
    <v-subheader class="title-setting">Mi Empresa</v-subheader>

    <v-form @submit.prevent ref="form" v-model="valid" class="py-4 px-4" v-on:submit.prevent="save">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field v-model="item.business_name" label="Razón Social" :rules="[rules.required]"
            :loading="loading_settings" />
          <!-- <v-text-field
            v-model="item.address"
            label="Direccion"
            :rules="[rules.required]"
            :loading="loading_settings"

          /> -->
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="item.cuit" label="CUIT" :rules="[rules.required]" :loading="loading_settings" />

        </v-col>


        <v-col cols="12" md="12" class="text-start">
          <div v-if="item.logo_url">
            <img :src="item.logo_url" style="object-fit: cover; max-width: 200px; max-height: 100px;background: rgba(0,0,0,0.5);
  padding: 15px;" alt="Logo actual" />
          </div>
          <div v-else>
            <v-avatar size="130">
              <v-img :src="require('@/assets/images/no-photo.png')" cover />
            </v-avatar>
          </div>
        </v-col>

        <v-col cols="12">
          <p class="caption">Tamaño recomendado 200x100px</p>
          <v-btn @click="uploadImage" color="primary" size="small">Adjuntar logo</v-btn>
          <v-file-input ref="image_ref" v-model="item.image_upload" accept="image/*" style="display: none"
            @change="setImage" />
        </v-col>

        <v-col cols="12" class="text-right mt-4">
          <v-btn :loading="loading" color="success" type="submit">Guardar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
    loading_settings: Boolean
  },
  mixins: [ValidMixin],
  watch: {
    mainItem: {
      handler(newVal) {
        this.item = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      item: JSON.parse(JSON.stringify(this.mainItem)), // copia profunda para evitar mutar la prop

    };
  },
  methods: {
    uploadImage() {
      this.$refs.image_ref.$el.querySelector("input[type='file']").click();
    },
    setImage() {
      if (this.item.image_upload) {
        this.item.logo_url = URL.createObjectURL(this.item.image_upload);
      }
    },
    save(e) {
      if (this.valid) {
        this.$emit("createItem", e, this.item, 'company');

      } else {
        console.log("Formulario no válido");
      }
    },
  },
};
</script>
